export const MESSAGES = {
  ON_PAUSE_OR_NOT_LOGGED:
    'Você não pode enviar mensagem enquanto estiver em pausa ou deslogado!'
};
